module.exports = __webpack_public_path__ + "img/xasc-icon.e4957575.png";